<template>
  <div id="pie"
       :style="size"
       style="display: flex;align-items:center;flex-direction: column">
    <e-charts :size="size"
              style="margin-top: 20px"
              :options="options" />
  </div>
</template>

<script>
import ECharts from './ECharts'

export default {
  props: {
    soldRerDay: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    ECharts,
  },
  data: function () {
    return {
      year: 2000,
      options: {
        color: [
          '#05f8d6',
          '#E75FC3',
          '#5085F2',
          '#8D7FEC',
          '#F87BE2',
          '#F2719A',
          '#FCA4BB',
          '#f89588',
          '#fdd845',
          '#22ed7c',
          '#09b0d3',
          '#1d27c9',
          '#f9e264',
          '#f47a75',
          '#009db2',
          '#024b51',
          '#0780cf',
          '#765005',
        ],
        title: {
          text: '日销量车数',
          // subtext: '（数据截止到：2022-05-26）',
          left: 'center',
          textStyle: {
            color: 'white',
          },
        },
        tooltip: {
          trigger: 'item',
          formatter: (params) => {
            return `${params.data.name}: ${params.data.value} 车`
          },
        },
        legend: {
          textStyle: {
            color: 'white',
            fontSize: 12,
          },
          orient: 'vertical',
          left: 'right',
          padding: [40, 30, 0, 0], // 上右下左
        },
        series: [
          {
            type: 'pie',
            radius: '70%',
            center: ['45%', '57%'], // 饼图距离上下边界距离，第一个数值表示左右位置，第二个数值表示上下位置，
            /* itemStyle : {    // 显示百分比
              normal : {
                label:{
                  show : true,
                  position : 'inner',
                  formatter: '{d}%',
                  distance : 0.7 ,// 这项是标识距离中心点的距离
                  textStyle : {
                    align : 'center',
                    baseline : 'middle',
                    fontFamily : '微软雅黑',
                    fontSize : 15,
                    fontWeight : 'bolder'
                  }
                },
                labelLine:{
                  show : true
                }
              }
            }, */
            data: this.soldRerDay,
            avoidLabelOverlap: true,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      },
      size: {
        width: '100%',
        height: '600px',
      },
    }
  },
}
</script>

<style scoped>
</style>
